import React from "react";
import styled from "styled-components";
import {
  BellOutlined,
  BulbOutlined,
  CheckCircleOutlined,
  CheckSquareOutlined,
  CloseCircleOutlined,
  DeleteOutlined,
  DownOutlined,
  EditOutlined,
  EllipsisOutlined,
  ExclamationCircleOutlined,
  FilterFilled,
  FilterOutlined,
  LeftOutlined,
  MailOutlined,
  PlusOutlined,
  ReloadOutlined,
  ScheduleOutlined,
  SearchOutlined,
  SendOutlined,
  StopOutlined
} from "@ant-design/icons";

// Icon map for tree-shaking optimization
const iconMap = {
  BellOutlined,
  BulbOutlined,
  CheckCircleOutlined,
  CheckSquareOutlined,
  CloseCircleOutlined,
  DeleteOutlined,
  DownOutlined,
  EditOutlined,
  EllipsisOutlined,
  ExclamationCircleOutlined,
  FilterFilled,
  FilterOutlined,
  LeftOutlined,
  MailOutlined,
  PlusOutlined,
  ReloadOutlined,
  ScheduleOutlined,
  SearchOutlined,
  SendOutlined,
  StopOutlined
};

const IconBg = styled.div`
  border-radius: 4px;
  color: #333;
  height: 2px;
  padding: 15px 12px;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover {
    background-color: #e7e7e7;
    cursor: pointer;
  }
  &:active {
    background-color: #d5d5d5;
  }
`;

export function ButtonOnBg(props) {
  const { icon, text, onClick, ...rest } = props;
  const IconComponent = icon ? iconMap[icon] : null;

  // Log warning if icon is requested but not found
  if (icon && !IconComponent) {
    console.warn(`Icon "${icon}" not found in ButtonOnBg iconMap. Available icons:`, Object.keys(iconMap));
  }

  return (
    <IconBg onClick={onClick} {...rest}>
      {IconComponent ? <IconComponent /> : null}
      {text ? <span style={{ marginLeft: 4 }}>{text}</span> : null}
    </IconBg>
  );
}
